import { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import { useAuth } from "pages/context/AuthContext";

import PageHeader from "pages/components/PageHeader";
import ProjectTable from "pages/components/ProjectTable/ProjectTable";
import DialogBarcodeReader from "pages/components/DialogBarcodeReader";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Fab from "@mui/material/Fab";
import Autocomplete from "@mui/material/Autocomplete";

import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";

import MDButton from "components/MDButton";

export default function InventarioDetalhe() {
  const { idinventario } = useParams();
  const { userData } = useAuth();
  const { showAlert } = useAlert();

  const idutilizador = Number(userData?.id || 0);

  const [loading, setLoading] = useState(false);
  const [inventario, setInventario] = useState(null);
  const [reloadInventario, setReloadInventario] = useState(0);

  const [materialContagem, setMaterialContagem] = useState(null);
  const [associacaoEANContagem, setAssociacaoEANContagem] = useState(null);
  const [quantidadeContagem, setQuantidadeContagem] = useState("");

  // Lotes disponíveis para o material em contagem.
  const [lotesContagem, setLotesContagem] = useState([]);
  const [loadingLotesContagem, setLoadingLotesContagem] = useState(false);
  const [erroLotesContagem, setErroLotesContagem] = useState(false);
  const [loteSelecionado, setLoteSelecionado] = useState(null);

  // Quantidades introduzidas individualmente por lote.
  // A chave é o código do lote e o valor é o texto introduzido.
  // Campo vazio significa que o lote não será contado.
  // O valor "0" representa uma contagem válida.
  const [quantidadesPorLote, setQuantidadesPorLote] = useState({});

  // Referências aos campos de quantidade, para regressar
  // ao lote correto quando o utilizador escolhe Recontar.
  const camposQuantidadeLotesRef = useRef({});

  // Lote que deve recuperar o foco após escolher Recontar.
  const loteRecontagemPendenteRef = useRef(null);

  // Quantidade a recuperar após escolher outra associação para o mesmo EAN.
  const [quantidadePendenteEAN, setQuantidadePendenteEAN] = useState(null);

  // Código de barras a reutilizar na escolha de outra associação.
  const [codigoPendenteEAN, setCodigoPendenteEAN] = useState(null);

  const [localizacaoContagem, setLocalizacaoContagem] = useState("");
  const [observacoesContagem, setObservacoesContagem] = useState("");

  // Consulta das contagens anteriores e preparação das confirmações.
  const [prepararContagemLoading, setPrepararContagemLoading] = useState(false);

  // Bloqueio síncrono contra preparações simultâneas.
  const preparacaoContagemEmCurso = useRef(false);

  // Gravação transacional efetiva de todos os lotes.
  const [guardarLoading, setGuardarLoading] = useState(false);

  // Bloqueio síncrono contra pedidos de gravação duplicados.
  const gravacaoContagensEmCurso = useRef(false);

  const [reloadMateriais, setReloadMateriais] = useState(0);

  // Anulação de todas as contagens válidas de um material.
  const [materialAnular, setMaterialAnular] = useState(null);
  const [motivoAnulacao, setMotivoAnulacao] = useState("");
  const [anularLoading, setAnularLoading] = useState(false);

  // Contagem anterior encontrada para o mesmo material/localização.
  const [confirmacaoContagem, setConfirmacaoContagem] = useState(null);

  // Sequência de contagens a processar, uma por cada lote.
  // Inclui os lotes não preenchidos, cuja quantidade será zero.
  const [contagensPendentes, setContagensPendentes] = useState([]);

  // Índice da próxima contagem a processar.
  // Permite retomar a sequência após confirmar uma contagem repetida.
  const [indiceContagemPendente, setIndiceContagemPendente] = useState(0);

  const [tipoConfirmacao, setTipoConfirmacao] = useState("");
  const [observacoesConfirmacao, setObservacoesConfirmacao] = useState("");

  const [openBarcodeReader, setOpenBarcodeReader] = useState(false);

  const [usarCameraBarcode, setUsarCameraBarcode] = useState(true);

  const [loadingMateriais, setLoadingMateriais] = useState(false);

  // Pesquisa de materiais para inventários LIVRE.
  const [termoPesquisaMaterial, setTermoPesquisaMaterial] = useState("");
  const [materiaisPesquisa, setMateriaisPesquisa] = useState([]);
  const [loadingPesquisaMaterial, setLoadingPesquisaMaterial] = useState(false);

  const limparPesquisaMaterial = () => {
    setTermoPesquisaMaterial("");
    setMateriaisPesquisa([]);
  };

  const [dadosMateriais, setDadosMateriais] = useState({
    total: 0,
    total_por_contar: 0,
    total_contados: 0,
    por_contar: [],
    contados: [],
  });

  // Atualizar o estado quando o utilizador regressa a esta janela.
  useEffect(() => {
    const atualizarAoFocar = () => {
      if (document.visibilityState === "visible") {
        setReloadInventario((anterior) => anterior + 1);
      }
    };

    window.addEventListener("focus", atualizarAoFocar);

    return () => {
      window.removeEventListener("focus", atualizarAoFocar);
    };
  }, []);

  useEffect(() => {
    if (!idutilizador || !idinventario) return;

    let ativo = true;

    const carregarInventario = async () => {
      setLoading(true);

      const [data, err] = await handleApi(
        api.post("Stocks/SelInventario", {
          idinventario: Number(idinventario),
          idutilizador,
        })
      );

      if (!ativo) return;

      setLoading(false);

      if (err) {
        showAlert(err, "error");
        setInventario(null);
        return;
      }

      setInventario(data || null);
    };

    carregarInventario();

    return () => {
      ativo = false;
    };
  }, [idinventario, idutilizador, reloadInventario]);

  useEffect(() => {
    if (!idutilizador || !idinventario || !inventario) return;

    let ativo = true;

    const carregarMateriais = async () => {
      setLoadingMateriais(true);

      const [data, err] = await handleApi(
        api.post("Stocks/SelInventarioMateriais", {
          idinventario: Number(idinventario),
          idutilizador,
        })
      );

      if (!ativo) return;

      setLoadingMateriais(false);

      if (err) {
        showAlert(err, "error");
        return;
      }

      setDadosMateriais({
        total: Number(data?.total || 0),
        total_por_contar: Number(data?.total_por_contar || 0),
        total_contados: Number(data?.total_contados || 0),
        por_contar: Array.isArray(data?.por_contar) ? data.por_contar : [],
        contados: Array.isArray(data?.contados) ? data.contados : [],
      });
    };

    carregarMateriais();

    return () => {
      ativo = false;
    };
  }, [idinventario, idutilizador, inventario, reloadMateriais]);

  // Pesquisa de qualquer material ativo num inventário LIVRE.
  useEffect(() => {
    if (
      !idutilizador ||
      !idinventario ||
      inventario?.modo !== "LIVRE" ||
      inventario?.dataencerramento ||
      termoPesquisaMaterial.trim().length < 2
    ) {
      setMateriaisPesquisa([]);
      setLoadingPesquisaMaterial(false);
      return;
    }

    let ativo = true;

    const timer = setTimeout(async () => {
      setLoadingPesquisaMaterial(true);

      try {
        const [data, err, meta] = await handleApi(
          api.post("Stocks/SelInventarioMateriaisPesquisa", {
            idinventario: Number(idinventario),
            idutilizador,
            term: termoPesquisaMaterial.trim(),
          })
        );

        if (!ativo) return;

        if (err || meta?.success === false) {
          setMateriaisPesquisa([]);
          showAlert(err || meta?.message || "Erro ao pesquisar materiais.", "error");
          return;
        }

        setMateriaisPesquisa(Array.isArray(data) ? data : []);
      } catch (error) {
        if (!ativo) return;

        setMateriaisPesquisa([]);
        showAlert(error?.message || "Erro ao pesquisar materiais.", "error");
      } finally {
        if (ativo) setLoadingPesquisaMaterial(false);
      }
    }, 350);

    return () => {
      ativo = false;
      clearTimeout(timer);
    };
  }, [
    idinventario,
    idutilizador,
    inventario?.modo,
    inventario?.dataencerramento,
    termoPesquisaMaterial,
  ]);

  const abrirContagem = (material, associacaoEAN = null) => {
    if (!material) return;

    // Não substituir o material enquanto uma preparação
    // ou gravação de contagens estiver em curso.
    if (
      preparacaoContagemEmCurso.current ||
      prepararContagemLoading ||
      gravacaoContagensEmCurso.current ||
      guardarLoading
    ) {
      showAlert("Aguarda pela conclusão da operação de contagem em curso.", "warning");
      return;
    }

    setMaterialContagem(material);
    setAssociacaoEANContagem(associacaoEAN);

    // Cada operação inicia uma nova contagem.
    // Nunca preencher com o total anteriormente contado.
    setQuantidadeContagem("");

    // Limpar as quantidades introduzidas por lote.
    // Os lotes não preenchidos serão gravados com zero,
    // mas apenas quando o utilizador confirmar a gravação.
    setQuantidadesPorLote({});

    // A localização pertence a esta contagem individual.
    // Não assumir automaticamente a localização antiga do material.
    setLocalizacaoContagem("");
    setObservacoesContagem("");
  };

  // Carregar os lotes do material selecionado para contagem.
  useEffect(() => {
    if (!materialContagem?.refmaterial || !idinventario || !idutilizador) {
      setLotesContagem([]);
      setLoteSelecionado(null);
      setLoadingLotesContagem(false);
      return undefined;
    }

    let ativo = true;

    const carregarLotes = async () => {
      setLoadingLotesContagem(true);
      setErroLotesContagem(false);
      setLotesContagem([]);
      setLoteSelecionado(null);

      try {
        const [data, err, meta] = await handleApi(
          api.post("Stocks/SelInventarioMaterialLotes", {
            idinventario: Number(idinventario),
            refmaterial: materialContagem.refmaterial,
            idutilizador,
          })
        );

        if (!ativo) return;

        if (err || meta?.success === false) {
          setErroLotesContagem(true);
          showAlert(err || meta?.message || "Erro ao consultar os lotes.", "error");
          return;
        }

        if (!Array.isArray(data?.lotes)) {
          setErroLotesContagem(true);
          showAlert("A API devolveu uma lista de lotes inválida.", "error");
          return;
        }

        const lotes = data.lotes;

        // Normalizar a identificação dos lotes e verificar duplicações.
        const codigosLotes = new Set();

        for (const item of lotes) {
          if (!item || typeof item !== "object") {
            setErroLotesContagem(true);
            showAlert("A API devolveu um lote inválido.", "error");
            return;
          }

          const codigoLote = String(item.lote ?? "").trim();

          if (codigosLotes.has(codigoLote)) {
            setErroLotesContagem(true);
            showAlert(
              `O lote '${codigoLote || "Sem lote"}' aparece repetido. ` +
                "Não é possível continuar a contagem.",
              "error"
            );
            return;
          }

          codigosLotes.add(codigoLote);
        }

        setLotesContagem(
          lotes.map((item) => ({
            ...item,
            lote: String(item.lote ?? "").trim(),
          }))
        );

        // Apenas selecionar automaticamente quando existe um único lote.
        if (lotes.length === 1) {
          setLoteSelecionado(String(lotes[0].lote ?? ""));
        }
      } catch (error) {
        if (ativo) {
          setErroLotesContagem(true);
          showAlert(error?.message || "Erro ao carregar os lotes.", "error");
        }
      } finally {
        if (ativo) setLoadingLotesContagem(false);
      }
    };

    carregarLotes();

    return () => {
      ativo = false;
    };
  }, [materialContagem?.refmaterial, idinventario, idutilizador]);

  // Identificar o lote cujo campo de quantidade deve receber o foco.
  // Preferir um lote com stock oficial positivo.
  // Se não houver nenhum, utilizar o primeiro lote.
  const indiceLoteFoco = useMemo(() => {
    if (lotesContagem.length === 0) return 0;

    const indicePositivo = lotesContagem.findIndex(
      (item) =>
        item.quantidade !== null && item.quantidade !== undefined && Number(item.quantidade) > 0
    );

    return indicePositivo >= 0 ? indicePositivo : 0;
  }, [lotesContagem]);

  // Linhas que serão apresentadas no formulário de contagem.
  // Quando não existem lotes, apresentar uma linha "Sem lote".
  const lotesParaContagem = useMemo(() => {
    if (lotesContagem.length > 0) {
      return lotesContagem;
    }

    return [
      {
        lote: "",
        quantidade: null,
        contado: 0,
        qtd_verificada: null,
        local_base: null,
        locais_alt: null,
      },
    ];
  }, [lotesContagem]);

  // Campos de quantidade individuais por lote.
  const renderCamposContagemLotes = () => (
    <MDBox display="grid" gap={1.5}>
      <MDTypography variant="button" fontWeight="bold">
        Quantidades contadas por lote
      </MDTypography>

      {lotesParaContagem.map((item, indice) => {
        const lote = String(item.lote ?? "");
        const quantidade = quantidadesPorLote[lote] ?? "";

        return (
          <MDBox
            key={lote}
            sx={{
              display: "grid",
              gridTemplateColumns: "minmax(0, 1fr) minmax(120px, 45%)",
              gap: 1.5,
              alignItems: "center",
              p: 1.5,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
            }}
          >
            <MDBox sx={{ minWidth: 0 }}>
              <MDTypography
                variant="button"
                fontWeight="bold"
                display="block"
                sx={{ overflowWrap: "anywhere" }}
              >
                {lote || "Sem lote"}
              </MDTypography>

              {item.quantidade !== null && item.quantidade !== undefined && (
                <MDTypography
                  variant="body2"
                  fontWeight="bold"
                  color="info"
                  display="block"
                  sx={{ mt: 0.5, fontSize: { xs: "0.9rem", sm: "0.95rem" } }}
                >
                  Stock oficial: {formatarQuantidadeStock(item.quantidade)}{" "}
                  {materialContagem?.unidade || ""}
                </MDTypography>
              )}

              <MDTypography
                variant="caption"
                fontWeight="bold"
                color={Number(item.contado) === 1 ? "success" : "text"}
                display="block"
              >
                {Number(item.contado) === 1 ? "Contado" : "Por contar"}
              </MDTypography>
            </MDBox>

            <TextField
              label="Qtd. contada"
              type="number"
              size="small"
              value={quantidade}
              inputRef={(elemento) => {
                if (elemento) {
                  camposQuantidadeLotesRef.current[lote] = elemento;
                } else {
                  delete camposQuantidadeLotesRef.current[lote];
                }
              }}
              onChange={(e) => {
                const novoValor = e.target.value;

                setQuantidadesPorLote((anterior) => ({
                  ...anterior,
                  [lote]: novoValor,
                }));

                // Qualquer alteração invalida as confirmações
                // anteriormente recolhidas para este material.
                setContagensPendentes([]);
                setIndiceContagemPendente(0);
                setConfirmacaoContagem(null);
                setTipoConfirmacao("");

                setObservacoesConfirmacao("");
              }}
              inputProps={{ min: 0, step: "any" }}
              autoFocus={indice === indiceLoteFoco}
              disabled={prepararContagemLoading || guardarLoading}
              fullWidth
            />
          </MDBox>
        );
      })}

      <MDTypography variant="caption" color="text">
        Os lotes não preenchidos serão registados com quantidade zero.
      </MDTypography>
    </MDBox>
  );

  const conversaoEANContagem = (() => {
    if (!associacaoEANContagem) return null;

    const tipo = String(associacaoEANContagem.tipo_conversao || "").toUpperCase();
    const unidades = Number(associacaoEANContagem.unidades_conversao);

    let numerador = 1;
    let denominador = 1;

    if (tipo === "B" && Number.isSafeInteger(unidades) && unidades > 1) {
      denominador = unidades;
    } else if (tipo === "C" && Number.isSafeInteger(unidades) && unidades > 1) {
      numerador = unidades;
    } else if (tipo !== "A") {
      const fator = Number(associacaoEANContagem.quantidade);

      if (!Number.isFinite(fator) || fator <= 0) return null;

      numerador = fator;
    }

    // Somar as quantidades introduzidas nos diferentes lotes.
    const quantidadesIntroduzidas = Object.values(quantidadesPorLote)
      .map((valor) => String(valor ?? "").trim())
      .filter((valor) => valor !== "");

    const valores = quantidadesIntroduzidas.map((valor) => Number(valor.replace(",", ".")));

    const quantidadeValida =
      valores.length > 0 && valores.every((valor) => Number.isFinite(valor) && valor >= 0);

    const quantidadeTotal = quantidadeValida
      ? valores.reduce((total, valor) => total + valor, 0)
      : null;

    return {
      codigo: String(associacaoEANContagem.codigo || ""),
      numerador,
      denominador,
      fator: numerador / denominador,
      quantidadeConvertida:
        quantidadeTotal !== null ? (quantidadeTotal * numerador) / denominador : null,
    };
  })();

  const converterQuantidadeParaStock = (quantidade) => {
    const valor = Number(quantidade);

    if (!Number.isFinite(valor)) return 0;

    if (!associacaoEANContagem) return valor;

    if (!conversaoEANContagem) return 0;

    return (valor * conversaoEANContagem.numerador) / conversaoEANContagem.denominador;
  };

  const formatarQuantidadeStock = (quantidade) =>
    Number(quantidade).toLocaleString("pt-PT", {
      maximumFractionDigits: 12,
    });

  // Preparar as quantidades a registar por lote.
  // Os lotes sem quantidade introduzida recebem zero.
  const prepararContagensLotes = () => {
    // Todos os lotes são incluídos na contagem.
    // Os campos vazios são considerados quantidade zero.
    const contagens = [];

    for (const item of lotesParaContagem) {
      const lote = String(item.lote ?? "");

      const textoOriginal = String(quantidadesPorLote[lote] ?? "").trim();

      const textoQuantidade = (textoOriginal || "0").replace(",", ".");

      const quantidade = Number(textoQuantidade);

      if (
        !/^\d+(\.\d{1,6})?$/.test(textoQuantidade) ||
        !Number.isFinite(quantidade) ||
        quantidade < 0 ||
        quantidade >= 1000000000000
      ) {
        showAlert(
          `Quantidade inválida no lote ${lote || "Sem lote"}. Máximo de 6 casas decimais.`,
          "warning"
        );
        return null;
      }

      contagens.push({
        lote,
        quantidade,
      });
    }

    return contagens;
  };

  // Construir o pedido de gravação transacional de todos os lotes.
  // Cada lote começa como INICIAL. As operações sobre contagens
  // existentes serão definidas depois das respetivas confirmações.
  const prepararPedidoContagensLotes = (contagens) => {
    if (!materialContagem || !Array.isArray(contagens) || contagens.length === 0) {
      return null;
    }

    return {
      idinventario: Number(idinventario),
      refmaterial: materialContagem.refmaterial,
      origem: associacaoEANContagem ? "EAN" : "MANUAL",
      codigo_ean: associacaoEANContagem ? conversaoEANContagem?.codigo : null,
      localizacao: localizacaoContagem.trim() || null,
      fator_numerador: conversaoEANContagem?.numerador ?? 1,
      fator_denominador: conversaoEANContagem?.denominador ?? 1,
      idutilizador,
      contagens: contagens.map((item) => {
        const temAnterior = Boolean(item.anterior);

        return {
          lote: item.lote,
          quantidade_lida: item.quantidade,
          tipo_operacao: temAnterior ? item.tipo_operacao || "INICIAL" : "INICIAL",
          idcontagem_anterior: temAnterior ? item.idcontagem_anterior ?? null : null,
          observacoes: temAnterior ? item.observacoes ?? null : null,
        };
      }),
    };
  };

  // Validar o conjunto completo antes da gravação transacional.
  // Nenhum lote pode ficar por confirmar ou ser omitido.
  const validarContagensLotesParaGravacao = (contagens) => {
    if (!Array.isArray(contagens) || contagens.length !== lotesParaContagem.length) {
      return "O conjunto de lotes está incompleto. Atualiza a contagem.";
    }

    const lotesEsperados = new Set(lotesParaContagem.map((item) => String(item.lote ?? "").trim()));

    const lotesRecebidos = new Set();

    for (const item of contagens) {
      const lote = String(item.lote ?? "").trim();
      const nomeLote = lote || "Sem lote";

      if (!lotesEsperados.has(lote) || lotesRecebidos.has(lote)) {
        return `O lote '${nomeLote}' está duplicado ou não pertence ao material.`;
      }

      lotesRecebidos.add(lote);

      const quantidade = item.quantidade;

      if (
        !Number.isFinite(quantidade) ||
        quantidade < 0 ||
        quantidade >= 1000000000000 ||
        !/^\d+(\.\d{1,6})?$/.test(String(quantidade))
      ) {
        return `Quantidade inválida no lote '${nomeLote}'.`;
      }

      if (item.anterior) {
        if (!["ACRESCENTAR", "SUBSTITUIR"].includes(item.tipo_operacao)) {
          return `Falta confirmar a operação do lote '${nomeLote}'.`;
        }

        if (
          !Number.isSafeInteger(Number(item.anterior.id)) ||
          Number(item.anterior.id) <= 0 ||
          Number(item.idcontagem_anterior) !== Number(item.anterior.id)
        ) {
          return `A confirmação anterior do lote '${nomeLote}' é inválida.`;
        }
      } else if (item.tipo_operacao && item.tipo_operacao !== "INICIAL") {
        return `O lote '${nomeLote}' não possui contagem anterior.`;
      } else if (item.idcontagem_anterior != null) {
        return `O lote '${nomeLote}' contém uma referência anterior inesperada.`;
      }
    }

    return null;
  };

  // Consultar a última contagem de cada lote na localização atual.
  // Ainda não grava qualquer quantidade.
  const consultarContagensAnterioresLotes = async (contagens) => {
    const resultados = await Promise.all(
      contagens.map(async (item) => {
        const [data, err, meta] = await handleApi(
          api.post("Stocks/SelInventarioUltimaContagem", {
            idinventario: Number(idinventario),
            refmaterial: materialContagem.refmaterial,
            lote: item.lote,
            localizacao: localizacaoContagem.trim() || null,
            idutilizador,
          })
        );

        if (err || meta?.success === false) {
          throw new Error(
            err || meta?.message || `Erro ao consultar o lote ${item.lote || "Sem lote"}.`
          );
        }

        if (!data || typeof data.existe !== "boolean") {
          throw new Error(`Resposta inválida para o lote ${item.lote || "Sem lote"}.`);
        }

        // Se existe uma contagem anterior, a API tem de devolver
        // uma identificação válida para permitir a sua confirmação.
        if (
          data.existe &&
          (!data.contagem ||
            !Number.isSafeInteger(Number(data.contagem.id)) ||
            Number(data.contagem.id) <= 0)
        ) {
          throw new Error(
            `A contagem anterior do lote ${item.lote || "Sem lote"} ` +
              "não possui uma identificação válida."
          );
        }

        // Validar também a quantidade da contagem anterior.
        // Evita cálculos incorretos nas operações de acréscimo.
        if (data.existe) {
          const quantidadeAnterior = data.contagem.quantidade_final;

          if (
            quantidadeAnterior === null ||
            quantidadeAnterior === undefined ||
            String(quantidadeAnterior).trim() === "" ||
            !Number.isFinite(Number(quantidadeAnterior)) ||
            Number(quantidadeAnterior) < 0
          ) {
            throw new Error(
              `A contagem anterior do lote ${item.lote || "Sem lote"} ` +
                "não possui uma quantidade válida."
            );
          }
        }

        return {
          ...item,
          anterior: data.existe ? data.contagem : null,
        };
      })
    );

    return resultados;
  };

  // Gravar todas as contagens do material numa única transação.
  // Esta função só deverá ser chamada depois de todas as
  // confirmações e validações estarem concluídas.
  const executarGravacaoContagensLotes = async (contagens) => {
    if (!materialContagem || gravacaoContagensEmCurso.current || guardarLoading) {
      return false;
    }

    // Nunca gravar sem uma consulta válida e concluída dos lotes.
    if (loadingLotesContagem || erroLotesContagem) {
      showAlert(
        "Os lotes deste material não estão disponíveis ou não foram " +
          "carregados corretamente. Fecha e volta a abrir a contagem.",
        "error"
      );
      return false;
    }

    if (inventario?.dataencerramento) {
      showAlert("Este inventário já está encerrado.", "warning");
      return false;
    }

    const erroValidacao = validarContagensLotesParaGravacao(contagens);

    if (erroValidacao) {
      showAlert(erroValidacao, "error");
      return false;
    }

    if (associacaoEANContagem && !conversaoEANContagem) {
      showAlert("Não foi possível determinar a conversão EAN.", "error");
      return false;
    }

    const pedido = prepararPedidoContagensLotes(contagens);

    if (!pedido) {
      showAlert("Não foi possível preparar o pedido de gravação.", "error");
      return false;
    }

    // Bloqueio imediato, sem depender de uma atualização do React.
    gravacaoContagensEmCurso.current = true;
    setGuardarLoading(true);

    try {
      const [data, err, meta] = await handleApi(
        api.post("Stocks/InsInventarioContagensLotes", pedido)
      );

      if (err || meta?.success === false) {
        showAlert(err || meta?.message || "Não foi possível guardar as contagens.", "error");
        return false;
      }

      if (
        !Array.isArray(data?.contagens) ||
        data.contagens.length !== pedido.contagens.length ||
        Number(data?.total_lotes) !== pedido.contagens.length
      ) {
        showAlert(
          "A API não confirmou corretamente a gravação de todos os lotes. " +
            "Atualiza os dados antes de tentar novamente.",
          "error"
        );
        return false;
      }

      const totalLotes = data.contagens.length;

      concluirContagemEAN();
      setReloadMateriais((anterior) => anterior + 1);

      showAlert(meta?.message || `${totalLotes} lote(s) registado(s) com sucesso.`, "success");

      return true;
    } catch (error) {
      showAlert(error?.message || "Erro ao guardar as contagens.", "error");
      return false;
    } finally {
      gravacaoContagensEmCurso.current = false;
      setGuardarLoading(false);
    }
  };

  const guardarContagem = async () => {
    if (
      !materialContagem ||
      preparacaoContagemEmCurso.current ||
      prepararContagemLoading ||
      guardarLoading ||
      gravacaoContagensEmCurso.current
    ) {
      return;
    }

    if (inventario?.dataencerramento) {
      showAlert("Este inventário já está encerrado.", "warning");
      return;
    }

    if (loadingLotesContagem) {
      showAlert("Aguarda pelo carregamento dos lotes.", "warning");
      return;
    }

    if (erroLotesContagem) {
      showAlert(
        "Não foi possível carregar os lotes deste material. " +
          "Fecha e volta a abrir a contagem antes de continuar.",
        "error"
      );
      return;
    }

    // Validar todas as quantidades introduzidas.
    // Os campos vazios são considerados zero.
    const contagens = prepararContagensLotes();

    if (!contagens) return;

    if (associacaoEANContagem && !conversaoEANContagem) {
      showAlert("Não foi possível determinar a conversão do código EAN.", "error");
      return;
    }

    preparacaoContagemEmCurso.current = true;
    setPrepararContagemLoading(true);

    try {
      // Consultar as contagens anteriores de todos os lotes.
      const contagensConsultadas = await consultarContagensAnterioresLotes(contagens);

      // Guardar temporariamente as contagens consultadas.
      // As operações sobre lotes já contados serão decididas
      // individualmente antes de construir o pedido transacional.
      // Ainda não executar qualquer gravação.
      setContagensPendentes(
        contagensConsultadas.map((item) => ({
          lote: item.lote,
          quantidade: item.quantidade,
          anterior: item.anterior,
        }))
      );

      setIndiceContagemPendente(0);

      // Identificar o primeiro lote com contagem anterior.
      const indicePrimeiraConfirmacao = contagensConsultadas.findIndex((item) => item.anterior);

      if (indicePrimeiraConfirmacao >= 0) {
        const item = contagensConsultadas[indicePrimeiraConfirmacao];

        if (!item.anterior?.id) {
          showAlert(
            `Não foi possível identificar a contagem anterior do lote ${item.lote || "Sem lote"}.`,
            "error"
          );
          return;
        }

        setIndiceContagemPendente(indicePrimeiraConfirmacao);

        setTipoConfirmacao("");

        setObservacoesConfirmacao("");

        setConfirmacaoContagem({
          lote: item.lote,
          anterior: item.anterior,
          quantidadeNova: item.quantidade,
        });

        return;
      }

      // Nenhum lote possui contagem anterior.
      // Validar o conjunto completo antes de o considerar preparado.
      const erroValidacao = validarContagensLotesParaGravacao(contagensConsultadas);

      if (erroValidacao) {
        setContagensPendentes([]);
        setIndiceContagemPendente(0);
        showAlert(erroValidacao, "error");
        return;
      }

      // Preparar o pedido transacional com todos os lotes.
      // Inclui quantidades zero nos campos não preenchidos.
      const pedidoValidado = prepararPedidoContagensLotes(contagensConsultadas);

      if (!pedidoValidado || pedidoValidado.contagens.length !== contagensConsultadas.length) {
        setContagensPendentes([]);
        setIndiceContagemPendente(0);
        showAlert("Não foi possível preparar o pedido completo de contagem.", "error");
        return;
      }

      // Nenhum lote possui contagem anterior.
      // Gravar todos os lotes numa única transação,
      // incluindo os que ficaram com quantidade zero.
      await executarGravacaoContagensLotes(contagensConsultadas);
    } catch (error) {
      showAlert(error?.message || "Erro ao preparar as contagens.", "error");

      setContagensPendentes([]);
      setIndiceContagemPendente(0);
    } finally {
      preparacaoContagemEmCurso.current = false;
      setPrepararContagemLoading(false);
    }
  };

  // Cancelar toda a sequência de confirmações, sem gravar.
  const cancelarConfirmacoesLotes = () => {
    if (
      preparacaoContagemEmCurso.current ||
      prepararContagemLoading ||
      guardarLoading ||
      gravacaoContagensEmCurso.current
    ) {
      return;
    }

    setConfirmacaoContagem(null);
    setContagensPendentes([]);
    setIndiceContagemPendente(0);
    setTipoConfirmacao("");

    setObservacoesConfirmacao("");
  };

  const confirmarContagemRepetida = () => {
    if (
      !confirmacaoContagem ||
      !materialContagem ||
      preparacaoContagemEmCurso.current ||
      prepararContagemLoading ||
      guardarLoading ||
      gravacaoContagensEmCurso.current
    ) {
      return;
    }

    if (!["SUBSTITUIR", "ACRESCENTAR", "RECONTAR"].includes(tipoConfirmacao)) {
      showAlert("Seleciona uma operação.", "warning");
      return;
    }

    if (!confirmacaoContagem.anterior?.id) {
      showAlert("Não foi possível identificar a contagem anterior.", "error");
      return;
    }

    if (tipoConfirmacao === "RECONTAR") {
      // Cancelar toda a operação, sem gravar.
      // Manter todas as quantidades e regressar ao primeiro lote.
      loteRecontagemPendenteRef.current = String(lotesParaContagem[0]?.lote ?? "");

      cancelarConfirmacoesLotes();
      return;
    }

    // Substituir e Acrescentar utilizam a quantidade
    // já introduzida no campo do respetivo lote.
    const textoQuantidade = String(confirmacaoContagem.quantidadeNova);

    const quantidadeValida =
      /^\d+(\.\d{1,6})?$/.test(textoQuantidade) &&
      Number.isFinite(Number(textoQuantidade)) &&
      Number(textoQuantidade) >= 0 &&
      Number(textoQuantidade) < 1000000000000;

    if (!quantidadeValida) {
      showAlert("Indica uma quantidade válida, com até 6 casas decimais.", "warning");
      return;
    }

    const quantidade = Number(textoQuantidade);

    // Aplicar a mesma operação a todos os lotes
    // que já possuem uma contagem anterior.
    // Os lotes sem contagem anterior permanecem INICIAL.
    const novasContagens = contagensPendentes.map((item) => {
      if (!item.anterior) return item;

      return {
        ...item,
        tipo_operacao: tipoConfirmacao,
        idcontagem_anterior: item.anterior.id,
        observacoes: observacoesConfirmacao.trim() || null,
      };
    });

    setContagensPendentes(novasContagens);

    // Todas as confirmações necessárias foram recolhidas.
    // Validar o conjunto antes de preparar a gravação transacional.
    const erroValidacao = validarContagensLotesParaGravacao(novasContagens);

    if (erroValidacao) {
      showAlert(erroValidacao, "error");
      return;
    }

    // Construir o pedido único, incluindo todas as decisões.
    // Ainda não executar qualquer gravação.
    const pedido = prepararPedidoContagensLotes(novasContagens);

    if (!pedido || pedido.contagens.length !== novasContagens.length) {
      showAlert("Não foi possível preparar o pedido de contagem.", "error");
      return;
    }

    setConfirmacaoContagem(null);
    setTipoConfirmacao("");

    setObservacoesConfirmacao("");
    setIndiceContagemPendente(0);

    executarGravacaoContagensLotes(novasContagens);
  };

  const anularContagensMaterial = async () => {
    if (!materialAnular || anularLoading) return;

    if (inventario?.dataencerramento) {
      showAlert("Não é possível anular contagens de um inventário encerrado.", "warning");
      return;
    }

    const motivo = motivoAnulacao.trim();

    if (!motivo) {
      showAlert("Indica o motivo da anulação.", "warning");
      return;
    }

    setAnularLoading(true);

    try {
      const [data, err, meta] = await handleApi(
        api.post("Stocks/CancelarInventarioMaterial", {
          idinventario: Number(idinventario),
          refmaterial: materialAnular.refmaterial,
          idutilizador,
          observacoes_cancelamento: motivo,
        })
      );

      if (err || meta?.success === false || !data?.total_anuladas) {
        showAlert(err || meta?.message || "Não foi possível anular as contagens.", "error");
        return;
      }

      setMaterialAnular(null);
      setMotivoAnulacao("");

      setReloadMateriais((anterior) => anterior + 1);

      showAlert(meta?.message || "Contagens anuladas com sucesso.", "success");
    } catch (error) {
      showAlert(error?.message || "Erro ao anular as contagens.", "error");
    } finally {
      setAnularLoading(false);
    }
  };

  const alterarAssociacaoEAN = () => {
    if (
      !associacaoEANContagem?.codigo ||
      prepararContagemLoading ||
      guardarLoading ||
      gravacaoContagensEmCurso.current
    ) {
      return;
    }

    // Guardar o EAN e a quantidade introduzida.
    setCodigoPendenteEAN(String(associacaoEANContagem.codigo).trim());
    setQuantidadePendenteEAN(quantidadeContagem);

    // Fechar a contagem atual, sem gravar.
    fecharContagem();

    // Voltar ao leitor para selecionar outra associação.
    setOpenBarcodeReader(true);
  };

  const concluirContagemEAN = () => {
    const continuarLeitura = Boolean(associacaoEANContagem);

    fecharContagem();

    if (continuarLeitura) {
      setOpenBarcodeReader(true);
    }
  };

  const fecharContagem = () => {
    setMaterialContagem(null);
    setAssociacaoEANContagem(null);
    setQuantidadeContagem("");

    // Limpar os dados da contagem por lotes.
    setQuantidadesPorLote({});
    setLotesContagem([]);
    setLoteSelecionado(null);
    setContagensPendentes([]);
    setIndiceContagemPendente(0);

    setLocalizacaoContagem("");
    setObservacoesContagem("");
    setConfirmacaoContagem(null);
    setTipoConfirmacao("");

    setObservacoesConfirmacao("");
  };

  const materiais = useMemo(() => {
    const lista = [...dadosMateriais.por_contar, ...dadosMateriais.contados];

    return lista.sort((a, b) => {
      const dataA = a?.data_registo ? new Date(a.data_registo).getTime() : 0;
      const dataB = b?.data_registo ? new Date(b.data_registo).getTime() : 0;

      return dataB - dataA;
    });
  }, [dadosMateriais]);

  const selecionarMaterialPorCodigo = async (associacao) => {
    const refmaterial = String(associacao?.refmaterial || "").trim();

    if (!refmaterial) {
      showAlert("O código lido não tem uma referência de material válida.", "warning");
      return;
    }

    let material = materiais.find((item) => String(item.refmaterial || "").trim() === refmaterial);

    if (!material && inventario?.modo === "LIVRE") {
      const [data, err, meta] = await handleApi(
        api.post("Stocks/SelInventarioMateriaisPesquisa", {
          idinventario: Number(idinventario),
          idutilizador,
          term: refmaterial,
        })
      );

      if (err || meta?.success === false) {
        showAlert(err || meta?.message || "Erro ao pesquisar o material.", "error");
        return;
      }

      material = (Array.isArray(data) ? data : []).find(
        (item) => String(item.refmaterial || "").trim() === refmaterial
      );
    }

    if (!material) {
      showAlert(`O material ${refmaterial} não pertence a este inventário.`, "warning");
      return;
    }

    if (inventario?.dataencerramento) {
      showAlert("Este inventário já está encerrado.", "warning");
      return;
    }

    abrirContagem(material, associacao);

    if (codigoPendenteEAN) {
      setQuantidadeContagem(quantidadePendenteEAN ?? "");
      setCodigoPendenteEAN(null);
      setQuantidadePendenteEAN(null);
    }
  };

  const mostrarQtdOficial = materiais.some(
    (material) => material.qtd_esperada !== null && material.qtd_esperada !== undefined
  );

  const colunasMateriais = useMemo(() => {
    const colunas = [
      {
        Header: "Referência",
        accessor: "refmaterial",
        width: 125,
      },
      {
        Header: "Material",
        accessor: "material",
        width: 360,
        minWidth: 220,
        Cell: ({ value }) => (
          <MDTypography variant="button" sx={{ whiteSpace: "normal", overflowWrap: "anywhere" }}>
            {value || "—"}
          </MDTypography>
        ),
      },

      {
        Header: "Qtd. contada",
        accessor: "qtd_verificada",
        width: 125,
        align: "right",
        sortType: "numPt",
        Cell: ({ value }) => value ?? "—",
      },
      {
        Header: "Unidade",
        accessor: "unidade",
        width: 95,
        Cell: ({ value }) => value || "—",
      },
    ];

    if (mostrarQtdOficial) {
      colunas.push(
        {
          Header: "Qtd. oficial",
          accessor: "qtd_esperada",
          width: 125,
          align: "right",
          sortType: "numPt",
          Cell: ({ value }) => value ?? "—",
        },
        {
          Header: "Diferença",
          accessor: "diferenca",
          width: 110,
          align: "right",
          sortType: "numPt",
          Cell: ({ value }) => value ?? "—",
        }
      );
    }

    if (inventario?.modo !== "LIVRE") {
      colunas.push({
        Header: "Estado",
        accessor: "contado",
        width: 125,
        filterType: "selectExact",
        filterOptions: [
          { value: "0", label: "Por contar" },
          { value: "1", label: "Contado" },
        ],
        Cell: ({ value }) => (
          <MDTypography
            variant="caption"
            fontWeight="bold"
            color={Number(value) === 1 ? "success" : "text"}
          >
            {Number(value) === 1 ? "Contado" : "Por contar"}
          </MDTypography>
        ),
      });
    }

    colunas.push(
      {
        Header: "Local principal",
        accessor: "local_base",
        width: 130,
        Cell: ({ value }) => value || "—",
      },
      {
        Header: "Outros locais",
        accessor: "locais_alt",
        width: 160,
        Cell: ({ value }) => value || "—",
      },
      {
        Header: "Data/Hora contagem",
        accessor: "data_registo",
        width: 165,
        Cell: ({ value }) => {
          if (!value) return "—";

          const data = new Date(value);

          if (Number.isNaN(data.getTime())) return "—";

          return data.toLocaleString("pt-PT", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          });
        },
      }
    );

    return colunas;
  }, [mostrarQtdOficial, inventario?.modo]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageHeader />

      <MDBox mt={2}>
        <Card>
          <MDBox p={{ xs: 2, md: 3 }}>
            {loading && (
              <MDBox py={2} display="flex" justifyContent="center">
                <CircularProgress size={28} />
              </MDBox>
            )}

            {!loading && !inventario && (
              <MDTypography variant="body2" color="text">
                Não foi possível carregar o inventário.
              </MDTypography>
            )}

            {!loading && inventario && (
              <>
                <MDTypography variant="h6">Detalhe do inventário</MDTypography>

                <MDTypography
                  variant="body2"
                  color="text"
                  sx={{ mt: 0.5, overflowWrap: "anywhere" }}
                >
                  {inventario.nome}
                </MDTypography>

                <MDBox
                  mt={2}
                  display="grid"
                  gap={2}
                  sx={{
                    gridTemplateColumns: {
                      xs: "1fr",
                      sm: "repeat(2, minmax(0, 1fr))",
                      lg: "repeat(4, minmax(0, 1fr))",
                    },
                  }}
                >
                  {[
                    ["Centro", inventario.centro],
                    ["Fabricante", inventario.fabricante],
                    ["Marca", inventario.marca],
                    ["Estado", inventario.dataencerramento ? "Encerrado" : "Aberto"],
                  ].map(([label, value]) => (
                    <MDBox key={label} sx={{ minWidth: 0 }}>
                      <MDTypography variant="caption" color="text" display="block">
                        {label}
                      </MDTypography>

                      <MDTypography
                        variant="button"
                        display="block"
                        sx={{ overflowWrap: "anywhere" }}
                      >
                        {value || "—"}
                      </MDTypography>
                    </MDBox>
                  ))}
                </MDBox>
              </>
            )}
          </MDBox>
        </Card>
      </MDBox>

      {inventario && (
        <MDBox mt={3}>
          <MDBox
            mb={2}
            display="grid"
            gap={2}
            sx={{
              gridTemplateColumns: {
                xs: "repeat(3, minmax(0, 1fr))",
              },
            }}
          >
            {[
              ["Total", dadosMateriais.total],
              ["Por contar", dadosMateriais.total_por_contar],
              ["Contados", dadosMateriais.total_contados],
            ].map(([titulo, valor]) => (
              <Card key={titulo}>
                <MDBox p={{ xs: 1.5, md: 2 }} textAlign="center">
                  <MDTypography
                    variant="subtitle1"
                    color="text"
                    fontWeight="bold"
                    sx={{ fontSize: { xs: "0.95rem", md: "1.1rem" } }}
                  >
                    {titulo}
                  </MDTypography>

                  <MDTypography variant="h5" fontWeight="bold">
                    {loadingMateriais ? "…" : valor}
                  </MDTypography>
                </MDBox>
              </Card>
            ))}
          </MDBox>

          {inventario.modo === "LIVRE" && !inventario.dataencerramento && (
            <Card sx={{ mb: 2 }}>
              <MDBox p={{ xs: 2, md: 3 }}>
                <MDTypography variant="h6" mb={2}>
                  Adicionar material à contagem
                </MDTypography>

                <Autocomplete
                  disableClearable
                  options={materiaisPesquisa}
                  loading={loadingPesquisaMaterial}
                  filterOptions={(options) => options}
                  value={null}
                  inputValue={termoPesquisaMaterial}
                  onInputChange={(_, novoValor, motivo) => {
                    if (motivo === "input" || motivo === "clear") {
                      setTermoPesquisaMaterial(novoValor);
                    }
                  }}
                  onChange={(_, material) => {
                    if (!material) return;

                    abrirContagem(material);
                    setTermoPesquisaMaterial("");
                    setMateriaisPesquisa([]);
                  }}
                  getOptionLabel={(option) => `${option.refmaterial} — ${option.material || ""}`}
                  isOptionEqualToValue={(option, value) =>
                    String(option.refmaterial) === String(value.refmaterial)
                  }
                  noOptionsText={
                    termoPesquisaMaterial.trim().length < 2
                      ? "Escreve pelo menos 2 caracteres."
                      : "Nenhum material encontrado."
                  }
                  loadingText="A pesquisar materiais..."
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Pesquisar material"
                      placeholder="Referência ou descrição..."
                      size="small"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingPesquisaMaterial && (
                              <CircularProgress color="inherit" size={18} />
                            )}

                            {Boolean(termoPesquisaMaterial) && (
                              <IconButton
                                size="small"
                                title="Limpar pesquisa"
                                aria-label="Limpar pesquisa"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  limparPesquisaMaterial();
                                }}
                                sx={{
                                  minWidth: 40,
                                  minHeight: 40,
                                  flexShrink: 0,
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            )}

                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.refmaterial}>
                      <MDBox sx={{ minWidth: 0 }}>
                        <MDTypography variant="button" fontWeight="bold" display="block">
                          {option.refmaterial}
                        </MDTypography>
                        <MDTypography
                          variant="caption"
                          color="text"
                          display="block"
                          sx={{ whiteSpace: "normal", overflowWrap: "anywhere" }}
                        >
                          {option.material}
                        </MDTypography>
                      </MDBox>
                    </li>
                  )}
                  sx={{ maxWidth: 750 }}
                />

                <MDTypography variant="caption" color="text" display="block" mt={1}>
                  Pesquisa qualquer material ativo. Ao selecioná-lo, abre-se o diálogo para registar
                  a quantidade encontrada.
                </MDTypography>
              </MDBox>
            </Card>
          )}

          <ProjectTable
            tableKey={`inventario-materiais-${idinventario}`}
            title="Materiais do inventário"
            subtitle="Consulta das referências e do estado das contagens"
            rowActions={[
              {
                id: "contar",
                icon: <Inventory2OutlinedIcon fontSize="small" />,
                tooltip: inventario.dataencerramento ? "Inventário encerrado" : "Registar contagem",
                color: "info",
                disabled: Boolean(inventario.dataencerramento),
                onClick: abrirContagem,
              },
              {
                id: "anular",
                icon: <DeleteOutlineIcon fontSize="small" />,
                tooltip: "Anular contagens deste material",
                color: "error",
                disabled: Boolean(inventario.dataencerramento),
                visible: (row) => Number(row.contado) === 1,
                onClick: (row) => {
                  setMaterialAnular(row);
                  setMotivoAnulacao("");
                },
              },
            ]}
            columns={colunasMateriais}
            data={materiais}
            loading={loadingMateriais}
            emptyMessage="Não foram encontrados materiais para este inventário."
            minWidth={950}
            maxHeight="65vh"
            showKeepFilters
          />
        </MDBox>
      )}

      <Dialog
        open={Boolean(materialAnular)}
        onClose={() => {
          if (anularLoading) return;
          setMaterialAnular(null);
          setMotivoAnulacao("");
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            mx: { xs: 1, sm: 2 },
            width: { xs: "calc(100% - 16px)", sm: "100%" },
            maxHeight: "calc(100dvh - 32px)",
          },
        }}
      >
        <DialogTitle>Anular contagens do material</DialogTitle>

        <DialogContent dividers>
          <MDBox display="grid" gap={2}>
            <MDTypography variant="body2">
              Esta operação irá anular todas as contagens válidas do material neste inventário,
              mantendo o histórico.
            </MDTypography>

            <MDBox>
              <MDTypography variant="button" fontWeight="bold" display="block">
                {materialAnular?.refmaterial}
              </MDTypography>

              <MDTypography variant="body2" color="text" sx={{ overflowWrap: "anywhere" }}>
                {materialAnular?.material}
              </MDTypography>
            </MDBox>

            <MDTypography variant="body2">
              Quantidade atualmente contada:{" "}
              <strong>{materialAnular?.qtd_verificada ?? "—"}</strong>
            </MDTypography>

            <TextField
              label="Motivo da anulação"
              value={motivoAnulacao}
              onChange={(e) => setMotivoAnulacao(e.target.value)}
              multiline
              minRows={2}
              required
              fullWidth
              autoFocus
              disabled={anularLoading}
              helperText="O motivo ficará registado no histórico da contagem."
            />

            <MDTypography variant="caption" color="error" fontWeight="bold">
              Esta operação não altera o stock oficial e não pode ser desfeita diretamente.
            </MDTypography>
          </MDBox>
        </DialogContent>

        <DialogActions sx={{ px: 2, py: 1.5, gap: 1, flexWrap: "wrap" }}>
          <MDButton
            color="secondary"
            variant="outlined"
            disabled={anularLoading}
            onClick={() => {
              setMaterialAnular(null);
              setMotivoAnulacao("");
            }}
          >
            Cancelar
          </MDButton>

          <MDButton
            color="error"
            disabled={anularLoading || !motivoAnulacao.trim()}
            onClick={anularContagensMaterial}
          >
            {anularLoading ? "A anular..." : "Confirmar anulação"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(materialContagem) && !confirmacaoContagem}
        onClose={() => {
          if (
            !preparacaoContagemEmCurso.current &&
            !prepararContagemLoading &&
            !gravacaoContagensEmCurso.current &&
            !guardarLoading
          ) {
            fecharContagem();
          }
        }}
        maxWidth="sm"
        fullWidth
        TransitionProps={{
          onEntered: () => {
            const lote = loteRecontagemPendenteRef.current;

            if (lote !== null) {
              camposQuantidadeLotesRef.current[lote]?.focus();
              loteRecontagemPendenteRef.current = null;
            }
          },
        }}
        PaperProps={{
          sx: {
            mx: { xs: 1, sm: 2 },
            width: { xs: "calc(100% - 16px)", sm: "100%" },
            maxHeight: "calc(100dvh - 32px)",
          },
        }}
      >
        <DialogTitle>Contagem de material</DialogTitle>

        <DialogContent dividers>
          {materialContagem && (
            <MDBox display="grid" gap={2}>
              <MDBox>
                <MDTypography variant="caption" color="text" display="block">
                  Referência
                </MDTypography>

                <MDTypography variant="h6">{materialContagem.refmaterial}</MDTypography>
              </MDBox>

              <MDBox>
                <MDTypography variant="caption" color="text" display="block">
                  Material
                </MDTypography>

                <MDTypography variant="body2" fontWeight="medium" sx={{ overflowWrap: "anywhere" }}>
                  {materialContagem.material}
                </MDTypography>
              </MDBox>

              <MDBox>
                <MDTypography variant="caption" color="text" display="block">
                  Unidade
                </MDTypography>

                <MDTypography variant="body2">{materialContagem.unidade || "—"}</MDTypography>
              </MDBox>

              {conversaoEANContagem && (
                <MDBox p={1.5} borderRadius="8px" sx={{ backgroundColor: "#eef4ff" }}>
                  <MDTypography variant="caption" color="text" display="block">
                    Código EAN lido
                  </MDTypography>

                  <MDTypography variant="button" fontWeight="bold" display="block">
                    {conversaoEANContagem.codigo}
                  </MDTypography>

                  <MDTypography variant="body2" mt={1}>
                    1 unidade lida equivale a{" "}
                    <strong>
                      {conversaoEANContagem.fator.toLocaleString("pt-PT", {
                        maximumFractionDigits: 12,
                      })}{" "}
                      {materialContagem.unidade || ""}
                    </strong>
                  </MDTypography>

                  {conversaoEANContagem.quantidadeConvertida !== null && (
                    <MDBox
                      mt={2}
                      p={2}
                      sx={{
                        border: "2px solid #2e7d32",
                        borderRadius: "10px",
                        backgroundColor: "#e8f5e9",
                        textAlign: "center",
                      }}
                    >
                      <MDTypography
                        variant="button"
                        fontWeight="bold"
                        sx={{ color: "#1b5e20", display: "block" }}
                      >
                        QUANTIDADE FINAL A REGISTAR NO INVENTÁRIO
                      </MDTypography>

                      <MDTypography variant="h4" fontWeight="bold" sx={{ color: "#1b5e20", mt: 1 }}>
                        {conversaoEANContagem.quantidadeConvertida.toLocaleString("pt-PT", {
                          maximumFractionDigits: 12,
                        })}{" "}
                        {materialContagem.unidade || ""}
                      </MDTypography>

                      <MDBox mt={1.5} pt={1.5} sx={{ borderTop: "1px solid #a5d6a7" }}>
                        <MDTypography
                          variant="button"
                          fontWeight="bold"
                          sx={{ color: "#1b5e20", display: "block" }}
                        >
                          Stock oficial
                        </MDTypography>

                        <MDTypography
                          variant="h5"
                          fontWeight="bold"
                          sx={{ color: "#1b5e20", mt: 0.5 }}
                        >
                          {materialContagem.qtd_esperada !== null &&
                          materialContagem.qtd_esperada !== undefined
                            ? `${Number(materialContagem.qtd_esperada).toLocaleString("pt-PT", {
                                maximumFractionDigits: 12,
                              })} ${materialContagem.unidade || ""}`
                            : "Não disponível"}
                        </MDTypography>
                      </MDBox>

                      <MDTypography
                        variant="caption"
                        sx={{ color: "#2e7d32", display: "block", mt: 1.5 }}
                      >
                        Confirma que esta é a quantidade pretendida antes de guardar.
                      </MDTypography>
                    </MDBox>
                  )}
                </MDBox>
              )}

              {loadingLotesContagem ? (
                <MDBox display="flex" alignItems="center" gap={1} py={2}>
                  <CircularProgress size={20} />
                  <MDTypography variant="body2" color="text">
                    A carregar lotes...
                  </MDTypography>
                </MDBox>
              ) : erroLotesContagem ? (
                <MDBox
                  p={2}
                  sx={{
                    border: "1px solid",
                    borderColor: "error.main",
                    borderRadius: 2,
                    bgcolor: "rgba(211, 47, 47, 0.05)",
                  }}
                >
                  <MDTypography variant="body2" color="error" fontWeight="bold" display="block">
                    Não foi possível carregar os lotes deste material.
                  </MDTypography>

                  <MDTypography variant="caption" color="text" display="block" mt={1}>
                    Fecha esta janela e volta a abrir a contagem para tentar novamente. Nenhuma
                    quantidade foi registada.
                  </MDTypography>
                </MDBox>
              ) : (
                renderCamposContagemLotes()
              )}
            </MDBox>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            px: 2,
            py: 1.5,
            gap: 1,
            flexWrap: "wrap",
            justifyContent: "flex-end",
          }}
        >
          {associacaoEANContagem && (
            <MDButton
              color="info"
              variant="outlined"
              onClick={alterarAssociacaoEAN}
              disabled={prepararContagemLoading || guardarLoading}
              sx={{ width: { xs: "100%", sm: "auto" } }}
            >
              Alterar associação
            </MDButton>
          )}

          <MDButton
            color="secondary"
            variant="outlined"
            disabled={prepararContagemLoading || guardarLoading || gravacaoContagensEmCurso.current}
            onClick={fecharContagem}
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            Fechar
          </MDButton>

          <MDButton
            color="success"
            disabled={
              prepararContagemLoading ||
              guardarLoading ||
              loadingLotesContagem ||
              erroLotesContagem ||
              gravacaoContagensEmCurso.current
            }
            onClick={guardarContagem}
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            {guardarLoading
              ? "A guardar..."
              : prepararContagemLoading
              ? "A preparar..."
              : "Guardar contagem"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(confirmacaoContagem)}
        onClose={cancelarConfirmacoesLotes}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            mx: { xs: 1, sm: 2 },
            width: { xs: "calc(100% - 16px)", sm: "100%" },
            maxHeight: "calc(100dvh - 24px)",
          },
        }}
      >
        <DialogTitle>Confirmar contagem existente</DialogTitle>

        <DialogContent dividers>
          {confirmacaoContagem && (
            <MDBox display="grid" gap={2}>
              <MDTypography variant="body2" fontWeight="bold">
                {materialContagem?.refmaterial} — {materialContagem?.material}
              </MDTypography>

              <MDTypography variant="body2" color="text">
                Já existem contagens anteriores para este material. Seleciona a operação a aplicar a
                todos os lotes com contagem anterior.
              </MDTypography>

              <MDBox sx={{ overflowX: "auto", width: "100%" }}>
                <MDBox
                  component="table"
                  sx={{
                    width: "100%",
                    minWidth: 380,
                    borderCollapse: "collapse",
                    "& th, & td": {
                      padding: "10px 8px",
                      borderBottom: "1px solid",
                      borderColor: "divider",
                      textAlign: "right",
                    },
                    "& th:first-of-type, & td:first-of-type": {
                      textAlign: "left",
                    },
                  }}
                >
                  <thead>
                    <tr>
                      <th>Lote</th>
                      <th>Anterior</th>
                      <th>Nova</th>
                      <th>Final</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contagensPendentes.map((item) => {
                      const anterior = Number(item.anterior?.quantidade_final || 0);
                      const nova = converterQuantidadeParaStock(item.quantidade);

                      const final =
                        !item.anterior || tipoConfirmacao === "SUBSTITUIR"
                          ? nova
                          : tipoConfirmacao === "ACRESCENTAR"
                          ? anterior + nova
                          : null;

                      return (
                        <tr key={item.lote}>
                          <td>{item.lote || "Sem lote"}</td>
                          <td>{item.anterior ? formatarQuantidadeStock(anterior) : "—"}</td>
                          <td>{formatarQuantidadeStock(nova)}</td>
                          <td>{final === null ? "—" : formatarQuantidadeStock(final)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </MDBox>
              </MDBox>

              <RadioGroup
                value={tipoConfirmacao}
                onChange={(e) => setTipoConfirmacao(e.target.value)}
              >
                <FormControlLabel
                  value="SUBSTITUIR"
                  control={<Radio />}
                  label="Substituir — Usar as novas quantidades nos lotes já contados"
                />

                <FormControlLabel
                  value="ACRESCENTAR"
                  control={<Radio />}
                  label="Acrescentar — Somar as novas quantidades às anteriores"
                />

                <FormControlLabel
                  value="RECONTAR"
                  control={<Radio />}
                  label="Recontar — Voltar à introdução das quantidades, sem gravar"
                />
              </RadioGroup>

              <TextField
                label="Observações (opcional)"
                value={observacoesConfirmacao}
                onChange={(e) => setObservacoesConfirmacao(e.target.value)}
                multiline
                minRows={2}
                fullWidth
              />
            </MDBox>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            px: 2,
            py: 1.5,
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          <MDButton
            color="secondary"
            variant="outlined"
            disabled={prepararContagemLoading || guardarLoading || gravacaoContagensEmCurso.current}
            onClick={cancelarConfirmacoesLotes}
          >
            Voltar
          </MDButton>

          <MDButton
            color="success"
            disabled={
              !tipoConfirmacao ||
              prepararContagemLoading ||
              guardarLoading ||
              gravacaoContagensEmCurso.current
            }
            onClick={confirmarContagemRepetida}
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            {tipoConfirmacao === "RECONTAR" ? "Voltar à contagem" : "Confirmar contagem"}
          </MDButton>
        </DialogActions>
      </Dialog>

      {inventario && !inventario.dataencerramento && (
        <>
          <MDBox
            sx={{
              position: "fixed",
              bottom: {
                xs: "calc(20px + env(safe-area-inset-bottom))",
                md: 28,
              },
              right: {
                xs: "calc(16px + env(safe-area-inset-right))",
                md: 28,
              },
              zIndex: 1200,
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "flex-end",
              gap: 1,
              maxWidth: "calc(100vw - 32px)",
            }}
          >
            <Tooltip title="Ler códigos através da câmera" placement="top">
              <Fab
                color="info"
                variant="extended"
                onClick={() => {
                  setUsarCameraBarcode(true);
                  setOpenBarcodeReader(true);
                }}
                sx={{
                  minHeight: 52,
                  px: 2,
                  boxShadow: 6,
                  whiteSpace: "nowrap",
                }}
              >
                <PhotoCameraIcon sx={{ mr: 1 }} />
                Usar Câmara
              </Fab>
            </Tooltip>

            <Tooltip title="Ler códigos com um leitor Barcode físico" placement="top">
              <Fab
                color="dark"
                variant="extended"
                onClick={() => {
                  setUsarCameraBarcode(false);
                  setOpenBarcodeReader(true);
                }}
                sx={{
                  minHeight: 52,
                  px: 2,
                  boxShadow: 6,
                  whiteSpace: "nowrap",
                  color: "#ffffff",
                  "& .MuiSvgIcon-root": {
                    color: "#ffffff",
                  },
                }}
              >
                <DocumentScannerIcon sx={{ mr: 1 }} />
                Usar Leitor Barcode
              </Fab>
            </Tooltip>
          </MDBox>

          <DialogBarcodeReader
            open={openBarcodeReader}
            onClose={() => {
              setOpenBarcodeReader(false);
              setCodigoPendenteEAN(null);
              setQuantidadePendenteEAN(null);
            }}
            onMaterialDetected={selecionarMaterialPorCodigo}
            permitirAssociacoes
            usarCamera={usarCameraBarcode}
            codigoInicial={codigoPendenteEAN}
            selecionarExplicitamente={Boolean(codigoPendenteEAN)}
          />
        </>
      )}
    </DashboardLayout>
  );
}
